import React from 'react';
import { useNavigate } from 'react-router-dom';

const CATEGORIES = [
  { slug: 'ecommerce', label: 'Ecommerce' },
  { slug: 'marketing', label: 'Marketing' },
  { slug: 'ai-tools',  label: 'AI Tools' },
  { slug: 'design',    label: 'Design' },
  { slug: 'developer', label: 'Developer' },
  { slug: 'writing',   label: 'Writing' },
  { slug: 'finance',   label: 'Finance' },
  { slug: 'learning',  label: 'Learning' },
  { slug: 'jobs',      label: 'Jobs' },
  { slug: 'health',    label: 'Health' },
];

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer style={styles.footer}>
      <div style={styles.inner}>
        <span style={styles.logo}>
          <span style={{ color: 'var(--teal)', fontStyle: 'italic' }}>u</span>Scope
        </span>
        <p style={styles.tagline}>The internet has great websites. We know where they are.</p>
        <div style={styles.links}>
          {CATEGORIES.map(cat => (
            <button
              key={cat.slug}
              style={styles.link}
              onClick={() => navigate(`/category/${cat.slug}`)}
            >
              {cat.label}
            </button>
          ))}
        </div>
        <p style={styles.copy}>© {new Date().getFullYear()} uScope</p>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    background: 'var(--dark)',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: 'clamp(36px, 6vw, 56px) clamp(16px, 4vw, 24px)',
  },
  inner: {
    maxWidth: '1040px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  logo: {
    fontFamily: 'var(--font-serif)',
    fontSize: '20px',
    color: 'var(--on-dark)',
  },
  tagline: {
    fontFamily: 'var(--font-sans)',
    fontSize: '14px',
    color: 'rgba(245,245,243,0.62)',
  },
  links: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
  },
  link: {
    background: 'none',
    border: 'none',
    fontFamily: 'var(--font-sans)',
    fontSize: '13px',
    color: 'rgba(245,245,243,0.65)',
    cursor: 'pointer',
    padding: '6px 10px',
    borderRadius: 'var(--radius-md)',
    transition: 'color var(--duration-fast) var(--ease)',
    minHeight: '36px',
  },
  copy: {
    fontFamily: 'var(--font-sans)',
    fontSize: '12px',
    color: 'rgba(245,245,243,0.42)',
    marginTop: '4px',
  },
};
